const parseMaybeUrlForRefCode = (
	text: string,
):
	| {
			refCode?: never;
			text: string;
	  }
	| {
			refCode: string;
			text: string;
	  } => {
	if (!text.includes("joinswsh.com") && !text.startsWith("http:") && !text.startsWith("https:")) {
		return { text };
	}
	// Splits on / and ?
	const split = text.split(/[/?]/);
	const albumIndex = split.indexOf("album");
	if (albumIndex !== -1) {
		const refCode = split[albumIndex + 1];
		if (refCode) {
			return {
				refCode,
				text,
			};
		}
	}

	const groupIndex = split.indexOf("group");
	if (groupIndex !== -1) {
		const refCode = split[groupIndex + 1];
		if (refCode) {
			return {
				refCode,
				text,
			};
		}
	}

	return {
		text,
	};
};

export default parseMaybeUrlForRefCode;
